import Vue from 'vue'
const USB = navigator.usb
const DAPjs = require('dapjs') // importはダメ
import {computeHash} from '../../lib/mbit-hash'
import env from '../../env'
import API from '../../api'

const state = {
    device: null,
    targetGroup: null
}

const getters = {
    connected() {
        return !!state.device
    }
}

const mutations = {
    addDevice(state, dev) {
        Vue.set(state, "device", dev)
    },
    rmDevice(state) {
        Vue.set(state, "device", null)
    },
    selectGroup(state, grpId) {
        state.targetGroup = grpId
    }
}

const actions = {
    connect(ctx, callback) {
        let chars = '';
        const handler = async (str) => {
            console.debug(`receive str: ${str}`)
            if (ctx.state.targetGroup === null)
                return
            if ((RegExp("^\u{FFFD}{2}", "u").test(str))) // 先頭のごみを削除
                str = str.slice(2)

            const parsed = str.split(',')
            const hash = computeHash(`${parsed[0]},${parsed[1]},${parsed[2]},${parsed[3]},${parsed[4]}`)
            if (hash != parsed[5]) {
                console.warn(`checksum error. ${hash}`)
                return
            }

            const received = {
                t: parsed[0],
                s: parsed[1],
                m: parsed[2],
                n: parsed[3],
                v: parsed[4]
            }

            if (received.n == "__now") { // 現在時刻を返すmagic変数
                await API.now()
                .then((res) => ctx.dispatch('serialWrite', res))
                .catch(e => callback(e))
                return
            }

            await ctx.dispatch('groups/getGroup', {gId: ctx.state.targetGroup}, {root: true})
            .then((grp) => {
                const founded = grp.Variables.find(i => i.Name === received.n)
                if (founded) {
                    if (received.m === "w") {
                        return ctx.dispatch('variables/sendData', {vId: founded.VariableID, data: received.v}, {root: true})
                    } else if (received.m === "r") {
                        if (founded.LatestData && founded.LatestData.Value) {
                            return ctx.dispatch('variables/getData', { vId: founded.VariableID, limit: 1 }, {root: true})
                            .then((res) => ctx.dispatch('serialWrite', res.Data[0].Value))
                        } else
                            return
                    } else { // received.m が未定義の場合
                        console.error("CSV format error. \"m\" is undefined.")
                    }
                } else {
                    if (received.m === "w") {
                        return ctx.dispatch('variables/registerVariable', {gId: ctx.state.targetGroup, name: received.n}, { root: true })
                        .then((v) => ctx.dispatch('variables/sendData', { vId: v.VariableID, data: received.v }, { root: true }))
                        .then(() => ctx.dispatch('groups/getGroup', {gId: ctx.state.targetGroup, opts: {refresh: true}} ,{root: true}))
                    } else if (received.m === "r") {
                        return ctx.dispatch('serialWrite', "err")
                    } else { // received.m が未定義の場合
                        console.error("CSV format error. \"m\" is undefined.")
                    }
                    return
                }
            })
            .catch(e => callback(e))
        }
        if (USB) {
            let target;
            if (!USB.ondisconnect) {
                // eslint-disable-next-line no-unused-vars
                USB.ondisconnect = _ => {
                    ctx.commit('rmDevice')
                }
            }
            return USB.requestDevice({
                'filters': [
                    { vendorId: env.USB_CONFIG.vendorId, product_id: env.USB_CONFIG.vendorId }
                ]
            })
            .then(dev => {
                const transport = new DAPjs.WebUSB(dev)
                target = new DAPjs.DAPLink(transport)
                target.on(DAPjs.DAPLink.EVENT_PROGRESS, data => {
                    console.warn(data)
                })
                target.on(DAPjs.DAPLink.EVENT_SERIAL_DATA, data => {
                    console.debug(data)
                    // if (/^[\u0020]*\u000D\u000A$/.test(data)) { // ゴミ行(CRLF)を削除
                    //     return
                    // }
                    chars += data.toString('utf8')
                    if (chars.includes('\r\n')) {
                        const separated = chars.split('\r\n')
                        handler(separated[0].trim())
                        chars = separated[1].toString('utf8')
                    }
                })
                return
            })
            .then(() => target.connect())
            .then(() => target.setSerialBaudrate(env.USB_CONFIG.baudrate))
            .then(() => {
                target.startSerialRead(0)
                ctx.commit('addDevice', target)
            })
        } else {
            return Promise.reject("WebUSB is not supported.")
        }
    },
    disconnect(ctx) {
        if (!ctx.state.device)
            return Promise.reject("device is not connected.")
        return Promise.resolve()
        .then(() => ctx.state.device.stopSerialRead())
        .then(() => ctx.state.device.disconnect())
        .then(() => ctx.commit('rmDevice'))
    },
    serialWrite(ctx, str) {
        console.debug(`send "${str}" to microbit`)
        if (ctx.state.device)
            return new Promise((resolve) => {
                ctx.state.device.stopSerialRead()
                setTimeout(() => {
                    resolve()
                }, 1000)
            })
            .then(() => ctx.state.device.serialWrite("" + str))
            .then(() => ctx.state.device.startSerialRead(0))
        return Promise.reject("fuga")
    },
    selectGroup(ctx, grpId) {
        ctx.commit('selectGroup', grpId)
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
